import { useContext, useState } from "react";

import { useNavigate } from "react-router-dom";

import { useAuth } from "../hooks/useAuth";
import { ToastContext } from "../Components/ToastProvider";
import LoadingButton from "../Components/LoadingButton";

function Unsubscribe() {
  // if we use a token for non-login unsubscribe, this will be needed
  // but also have to generate a token to give to the email newsletter
  // so for now, no token, but user has to be logged in.
  //   const { token } = useParams();

  const { updateUser } = useAuth();

  const { createToast } = useContext(ToastContext);

  const navigate = useNavigate();

  const [disabled, setDisabled] = useState(false);

  const handleNo = () => {
    setDisabled(true);
    createToast("Enjoy Fudopia", "success", true);
    navigate("/");
  };

  const handleYes = () => {
    // no token needs to be passed because they are logged in to reach this page
    // as it is a protected route.  It will unsubscribe the logged in user
    setDisabled(true);
    updateUser({ newsletterSubscribed: false }).then(async (success) => {
      if (success) {
        createToast("Unsubscribed!  Enjoy Fudopia", "success", true);
        navigate("/");
      } else {
        setDisabled(false);
      }
    });
  };
  return (
    <div>
      <h1>Are you sure you want to unsubscribe from the newsletter?</h1>
      <div>
        <LoadingButton onClick={handleYes} disabled={disabled}>
          Yes
        </LoadingButton>
        <LoadingButton onClick={handleNo} disabled={disabled}>
          No
        </LoadingButton>
      </div>
    </div>
  );
}

export default Unsubscribe;
